// common styles
const styles = {
  container: {
    padding: 12,
    backgroundColor: "#000000d0",
    height: 162,
  },
  backing: {
    paddingLeft: 6,
    paddingRight: 6,
    backgroundColor: "transparent",
    position: "relative",
  },
  cardContainer: {
    width: 243,
    height: 126,
    padding: 8,
    backgroundColor: "#3c3c3c",
  },
  selected: {
    backgroundColor: "#6b6b6b",
  },
  header: {
    height: 80,
  },
  title: {
    color: "#fff",
    fontSize: 15,
    maxWidth: "137px",
    wordWrap: "break-word",
  },
  price: {
    color: "#cecece",
    fontSize: 13,
    maxWidth: 116,
  },
  divider: {
    width: 116,
    height: 1,
    backgroundColor: "#ffd200",
  },
  image: {
    width: 90,
    height: 90,
    alignSelf: "center",
  },
  info: {
    position: "absolute",
    bottom: 0,
    left: 4,
    padding: 4,
  },
  selectedIcon: {
    position: "absolute",
    top: 4,
    right: 10,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/styles.js